import React from 'react';
import {theme, Typography} from "antd";

const ErrorNotFound = () => {

    const { Title } = Typography;

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <div className="site-layout-content"
             style={{background: colorBgContainer, display: 'flex', justifyContent: 'center'}}>
            <div>
                <p>
                    <strong>Error 404:</strong> La página solicitada no ha sido encontrada.
                </p>
                <p>
                    <a href="/alta1a1/">Volver a la página principal</a>
                </p>
            </div>
        </div>
    );
}

export default ErrorNotFound;



